import React, { useEffect } from "react";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import OverviewCard from "../../../components/cards/OverviewCard";
import { PackageCheck } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { fetchProductStatsAsync } from "../../../redux/features/ProductSlice";

const ProductSummary = () => {
  const { productStats, loading } = useAppSelector((state) => state.products);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductStatsAsync());
  }, [dispatch]);

  return (
    <WhiteTitledCard cardTitle="Products Overview">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        <OverviewCard
          title="Total Products"
          value={productStats?.totalProducts ?? 0}
          icon={PackageCheck}
          iconBg="bg-indigo-500"
          isLoading={loading}
        />
        <OverviewCard
          title="Approved"
          value={productStats?.approvedProducts ?? 0}
          icon={PackageCheck}
          iconBg="bg-green-500"
          isLoading={loading}
        />
        <OverviewCard
          title="Pending"
          value={productStats?.pendingProducts ?? 0}
          icon={PackageCheck}
          iconBg="bg-yellow-500"
          isLoading={loading}
        />
        <OverviewCard
          title="Rejected"
          value={productStats?.rejectedProducts ?? 0}
          icon={PackageCheck}
          iconBg="bg-red-500"
          isLoading={loading}
        />
        <OverviewCard
          title="Sold Quantity"
          value={productStats?.totalSoldQuantity ?? 0}
          icon={PackageCheck}
          iconBg="bg-blue-500"
          isLoading={loading}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default ProductSummary;
